'use client'
import React, { useState } from 'react'
import { Image, Tab, TabList, Tabs } from '@chakra-ui/react'
import { usePathname } from 'next/navigation'
import { px } from 'framer-motion'

interface LykcoinUsdollarToggleProps {
  onTabChange: (isLykCoins: boolean) => void
}

const LykcoinUsdollarToggle: React.FC<LykcoinUsdollarToggleProps> = ({
  onTabChange,
}) => {
  const pathname = usePathname()
  const [tabIndex, setTabIndex] = useState(0)
  const inactiveIcon = '/logo-color-circle.svg'
  const isCreatorAnalytics = pathname === '/creator-analytics'

  const tabs = [
    {
      label: 'LYK Coins',
      icon: '/logo-circle.svg',
      inactiveIcon: inactiveIcon,
    },
    { label: 'US$', icon: null },
  ]

  const handleTabClick = (index: number) => {
    setTabIndex(index)
    onTabChange(index === 0)
  }

  return (
    <Tabs
      onChange={(index) => setTabIndex(index)}
      variant="soft-rounded"
      colorScheme="green"
      size="sm"
    >
      <TabList className="rounded-full border-2 border-[#D3D3D3] p-0.5">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            onClick={() => handleTabClick(index)}
            bg={tabIndex === index ? '#24BFA3' : '#FFFFFF'}
            color={tabIndex === index ? '#FFFFFF' : '#9F9F9F'}
            _selected={{ bg: '#24BFA3', color: '#FFFFFF' }}
            sx={{
              px: isCreatorAnalytics ? { base: '5px', sm: '10px' } : '10px',
            }}
          >
            {tab.icon && index === 0 && (
              <Image
                boxSize={5}
                mr={1}
                src={tabIndex === index ? tab.icon : tab.inactiveIcon}
                alt={tab.label}
              />
            )}
            {tab.label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  )
}

export default LykcoinUsdollarToggle
